var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _defs, _g23, _g24, _path, _path2, _g25, _g26, _path3, _g27, _g28, _g29, _g30, _path4, _g31, _g32, _circle, _ellipse, _g33, _g34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJackrusselDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 126.1 126.1",
    style: {
      enableBackground: "new 0 0 126.1 126.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000021841011204711084660000012998499742161928325_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#000000;stroke-width:1.5947;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:1.6877;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.2932;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:1.5959;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#F4BD22;}\n\t.st8{fill:none;stroke:#000000;stroke-width:1.6877;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#010202;stroke:#000000;stroke-miterlimit:10;}\n\t.st10{fill:#F4BD22;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#EA5152;}\n\t.st12{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st14{fill:#E16E2D;}\n\t.st15{fill:#333333;stroke:#000000;stroke-width:1.6877;stroke-miterlimit:10;}\n\t.st16{display:none;}\n\t\n\t\t.st17{display:inline;fill:none;stroke:#000000;stroke-width:1.3766;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "corpo"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "medaglia"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "orecchio_sinistro"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "testa"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "occhio_sinistro"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "occhio_destro"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "orecchio_destro"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._sinistra"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Corpo_00000112613845603693607520000013567454986413836214_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Coda_00000107584135948157661530000007463130393841503394_"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_post._destra_00000173127137154842632420000015756738647979321244_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._destra_00000065061667640867522800000000209746375277762728_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Anello"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Collare_00000025400726651283256580000010377002230540005792_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "porta_tag"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medaglietta"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Lingua_00000042739141217044383000000010566187223174954169_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_sinistro_00000176738367563206018490000002636450091066938762_"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Testa_00000101791726587625758750000003926374502748059038_"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Naso_00000062913539313010745270000018036393316476855979_"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_destro_00000150103011012674864800000014049399545590072707_"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Occhio_aperto"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pipilla"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 126.1,
    height: 126.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183964165331609972130000006973267989762407856_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183964165331609972130000006973267989762407856_)"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._sinista"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "60,99.2 61.4,146.6 49,146.6 47.3,108  "
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "60,99.2 61.4,146.6 49,146.6 47.3,108  "
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Corpo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.6,77.6c-12.4,23.2-24.9,46.5-37.3,69.7c1.8,0.6,26.2,7.7,45.9-8.5c14.8-12.1,21-32.4,15.7-51.4 C50.8,84.1,42.7,80.9,34.6,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.6,77.6c-11.4,21.3-22.8,42.6-34.2,63.9c-1.6,3,0.2,6.8,3.6,7.2c9,1.3,25.2,1.5,39.2-10 c14.8-12.1,21-32.4,15.7-51.4C50.8,84.1,42.7,80.9,34.6,77.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 3.1,
    cy: 144.1,
    rx: 5.2,
    ry: 3.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Coda",
    className: "st4",
    d: "M2.7,139.1c-3.5-0.2-6.6-1.6-9.4-5.3c-2.8-3.7-4.7-7.2-6-10c-1,0.9-3.4,3.5-3.8,7.5 c0,0.4-0.4,2,0.3,3.8c0.6,1.7,2.7,6.6,8.1,10c4,2.6,8.1,3.2,10.5,3.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Zampa_post._destra",
    className: "st5",
    d: "M9.8,149.3c14.4,0,15.9,0,30.3,0c0.1-2.9,0.1-5.8,0.2-8.7c-3.2-0.7-6.4-1.3-9.6-2 c0.2-0.8,1.7-7-2.2-12.2c-2.4-3.2-5.6-4.3-6.9-4.7"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Zampa_ant._destra"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "58.6,100.4 56.5,149.6 44.1,149.6 42.5,110.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "58.6,100.4 56.5,149.6 44.1,149.6 42.5,110.9  "
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Collare"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.4,90.2c-3.3,0.3-9.1,0.5-15.8-1.6c-6.9-2.2-11.7-5.7-14.2-8c1-3.2,2-6.4,3-9.6c2,2.2,5.8,5.8,11.5,8.3 c7.6,3.3,14.5,2.9,17.7,2.5C62.8,84.6,62.1,87.4,61.4,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M61.4,90.2c-3.3,0.3-9.1,0.5-15.8-1.6c-6.9-2.2-11.7-5.7-14.2-8c1-3.2,2-6.4,3-9.6c2,2.2,5.8,5.8,11.5,8.3 c7.6,3.3,14.5,2.9,17.7,2.5C62.8,84.6,62.1,87.4,61.4,90.2z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M54.5,80.5L52,92.1c-0.1,0.7-0.1,1.4,0.2,1.5c0.4,0.2,1.2-0.3,1.8-1.3c0.9-3.9,1.7-7.8,2.6-11.6L54.5,80.5z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M50.1,101.6h4c0,0.1,0.2,1.1,1,1.6c0.8,0.5,1.8,0.4,2.5-0.2c0.7-0.6,1-1.5,0.7-2.4c-0.3-1-1.2-1.4-1.4-1.4 c0.1,0,1.1-0.4,1.4-1.4c0.3-0.9-0.1-1.8-0.8-2.4c-0.7-0.5-1.7-0.6-2.4-0.2c-0.9,0.5-1.1,1.5-1.1,1.6c-1.3,0-2.7,0-4,0 c0-0.2-0.2-1-0.9-1.5c-0.8-0.6-1.8-0.5-2.6,0c-0.6,0.5-1,1.2-0.9,2c0.1,0.8,0.6,1.5,1.4,1.8c-0.2,0.1-0.8,0.4-1.2,1 c-0.5,0.9-0.3,2.1,0.5,2.7c0.6,0.5,1.6,0.7,2.3,0.3C49.9,102.8,50.1,101.7,50.1,101.6z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Lingua"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M86.1,80.8c0.6,0.4,2.3,2,3,4.7c0.6,2.4-0.1,4.3-0.3,5c-0.1,0.2-1.3,2.3-3.7,2.6c-1.9,0.3-3.8-0.6-4.9-2.2 c0.2-1.1,0.5-2.8,0.1-4.9c-0.6-3.2-2.4-5.3-3.2-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.1,80.8c0.6,0.4,2.3,2,3,4.7c0.6,2.4-0.1,4.3-0.3,5c-0.1,0.2-1.3,2.3-3.7,2.6c-1.9,0.3-3.8-0.6-4.9-2.2 c0.2-1.1,0.5-2.8,0.1-4.9c-0.6-3.2-2.4-5.3-3.2-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M82.9,80.7c0.5,0.6,1.2,1.5,1.7,2.8c0.8,2.3,0.5,4.4,0.2,5.3"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_sinistro"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M51.2,36.4c5.8-5.6,11.5-11.3,17.3-16.9c0.7,2,1.8,5.9,1.2,10.9c-0.6,5.1-2.6,8.7-3.7,10.6 c-0.9,1.2-1.7,2.4-2.6,3.6C59.3,41.8,55.2,39.1,51.2,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M51.2,36.4c5.8-5.6,11.5-11.3,17.3-16.9c0.7,2,1.8,5.9,1.2,10.9c-0.6,5.1-2.6,8.7-3.7,10.6 c-0.9,1.2-1.7,2.4-2.6,3.6C59.3,41.8,55.2,39.1,51.2,36.4z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Testa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,72.6c3.4,2.3,7.6,4.9,12.6,7.2c4.5,2.1,8.7,3.5,12.3,4.5c4.8,1.3,12,2.8,20.4,0.5 c7.2-2,12.2-6,15.2-9c1.4-1.5,3.1-3.8,4.5-6.7c1.1-2.2,1.7-4.3,2.1-6C86.4,53.6,68.7,44,51,34.4c-1.4,0.3-11.7,2.5-16.8,12.4 C30.1,54.9,31.1,65,36.9,72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M65.8,60.7c-1.8,5.8-8.5,10.4-14.1,12c-1.7,0.4-4.2,0.9-7.3,0.7c-4-0.3-7-1.8-8.7-2.7 c-1.2-3.2-2.4-6.4-3.6-9.5l1.2-11.7l5.9-8.8c1.7-1.2,3.4-2.5,5.1-3.7c1.1-0.3,2.2-0.7,3.3-1C61.5,40.4,68.3,52.5,65.8,60.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "60.4,39.8 93.4,64 104.1,63.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.9,72.6c3.4,2.3,7.6,4.9,12.6,7.2c4.5,2.1,8.7,3.5,12.3,4.5c4.8,1.3,12,2.8,20.4,0.5 c7.2-2,12.2-6,15.2-9c1.4-1.5,3.1-3.8,4.5-6.7c1.1-2.2,1.7-4.3,2.1-6C86.4,53.6,68.7,44,51,34.4c-1.4,0.3-11.7,2.5-16.8,12.4 C30.1,54.9,31.1,65,36.9,72.6z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Naso",
    className: "st15",
    d: "M103.5,63.5c-5.4,0.6-10.8,1.2-16.3,1.8c0.7,3.6,2.9,6.5,5.8,7.2C97.1,73.6,102.7,70,103.5,63.5z "
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Orecchio_destro"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M48.9,39.3l-15-11.9C31.7,28.8,27.1,32,23.8,38c-3.9,7.2-3.5,14-3.2,16.5c1.4,4,2.8,4.8,3.8,4.9 c2.9,0.3,4.6-5.6,11.4-11.4c2.5-2.2,4.8-3.6,6.3-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M48.9,39.3l-15-11.9c-1.9,1-7,4.1-10.2,10.5c-2.8,5.5-2.6,10.7-2.5,12.9c0.7,6.8,2,8.3,3,8.5 c2.3,0.5,4.3-5.4,11.4-11.4c2.5-2.1,4.9-3.6,6.3-4.4"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Occhio"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 49,
    cy: 55,
    r: 9.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 56.1,
    r: 3.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 53,
    cy: 54.4,
    rx: 2.9,
    ry: 1
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Occhio_chiuso_00000016038507266870349340000004235187398372083854_",
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Occhio_chiuso",
    className: "st17",
    d: "M57.9,56.6c-1-0.8-4.2-3.4-8.7-2.9C44.8,54.1,42,57,41.1,58"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackrusselDefault);
export default __webpack_public_path__ + "static/media/jackrussel_default.81b4b0677cdae2e187dc5f257f5bf13a.svg";
export { ForwardRef as ReactComponent };